import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextHighlight"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 22.5H22.5V1.5L1.5 22.5ZM21 21H15.75C14.5074 21 13.5 19.9926 13.5 18.75V17.25C13.5 16.0074 14.5074 15 15.75 15H19.5V13.5C19.5 13.0858 19.1642 12.75 18.75 12.75H14.25V11.25H18.75C19.9926 11.25 21 12.2574 21 13.5V21ZM3.75 11.25H9V3.75C9 2.50736 7.99264 1.5 6.75 1.5H2.25V3H6.75C7.16421 3 7.5 3.33579 7.5 3.75V5.25H3.75C2.50736 5.25 1.5 6.25736 1.5 7.5V9C1.5 10.2426 2.50736 11.25 3.75 11.25ZM3.75 6.75C3.33579 6.75 3 7.08579 3 7.5V9C3 9.41421 3.33579 9.75 3.75 9.75H7.5V6.75H3.75ZM15 18.75V17.25C15 16.8358 15.3358 16.5 15.75 16.5H19.5V19.5H15.75C15.3358 19.5 15 19.1642 15 18.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextHighlight.vue"]]);
